// Function to show or hide the banner
const bannerScroll = throttle( function (){

	// Get the banner
	const banner = document.querySelector( '.banner' );

	// If we are below the header
	if( pastHeader() ){

		// Show the banner as a full navigation
		banner.classList.add( 'banner--full' );

	// We are in the header
	} else {

		// Only show the banner as a topic list
		banner.classList.remove( 'banner--full' );
	}

}, 100);

function bannerAnalytics(){
	[].slice.call( document.querySelectorAll( '.banner__nav__link' )).forEach(
		x => x.addEventListener( 'click', function(){
			dataLayer.push({
				'category': 'Interactive',
				'action': 'Navigation',
				'label': this.getAttribute( 'href' ),
				'event': 'Interactive'
			});
		})
	);
}
